import { FormDragAndDropFileUploader } from "components/form-fields/FormDragAndDropFileUploader";
import { DOCUMENT_ALLOWED_FILE_TYPES, DOCUMENT_MAX_FILE_SIZE_BYTES } from "pages/documents/shared/DocumentConfiguration";
import PropTypes from "prop-types";
import React from "react";

export function OrganisationDocuments({
    newDocuments,
    onUpload,
    onRemove,
    saving = false,
    loading = false
}) {
    return (<div>
        <h2>Upload Organisation Documents</h2>
        <p className="intro-text">Please upload the documents for your organisation document type.</p>
        <FormDragAndDropFileUploader 
            id="organisation-documents-uploader"
            loading={loading || saving}
            smaller={!!newDocuments.length}
            onChange={onUpload}
            documents={newDocuments.map(x => ({
                name: x.name,
                size: x.size,
                loadingVersion: false,
                version: 1
            }))}
            onRemoveDocument={onRemove}
            maxFileSize={DOCUMENT_MAX_FILE_SIZE_BYTES}
            allowedFileTypes={DOCUMENT_ALLOWED_FILE_TYPES}
        />
    </div>)
}

OrganisationDocuments.propTypes = {
    newDocuments: PropTypes.array.isRequired,
    onUpload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    saving: PropTypes.bool,
    loading: PropTypes.bool
}